"use client";

import Image from "next/image";
import React from "react";

const SectionWithImage = ({
  headings,
  description,
  asterisk,
  background = "bg-white",
  textToLeft,
  imageSrc,
}) => {
  return (
    <div className={`w-full ${background} pt-10 pb-10`}>
      <div className="flex flex-col md:flex-row justify-center items-center max-w-screen-lg mx-auto">
        {/* Image Section */}
        <div
          className={`order-1 ${textToLeft ? "md:order-2" : "md:order-1"
            } flex-shrink-0`}
        >
          <div className="w-[350px] md:w-[600px]">
            <Image
              src={imageSrc}
              alt="Section Image"
              width={600}               // intrinsic width
              height={400}              // intrinsic height (3:2 ratio)
              style={{
                width: '100%',          // scale to container width
                height: 'auto'          // keep aspect ratio
              }}
              className="object-cover"
            />
          </div>

        </div>

        {/* Text Section */}
        <div
          className={`order-2 ${textToLeft ? "md:order-1" : "md:order-2"
            } mt-8 md:mt-0 md:ml-8 md:mr-8 max-w-xs md:max-w-lg`}
        >
          <div className="max-w-lg text-left md:text-left">
            <h1 className="text-[48px] font-bold text-black leading-tight mb-2 fullfont-tradeGothicCondensedBold">
              {Array.isArray(headings)
                ? headings.map((heading, index) => (
                  <span key={index} className="block">
                    {heading}
                  </span>
                ))
                : headings}
            </h1>
            <p className="text-[16px] text-black lg:pr-16 font-trade_gothic_lt_std mr-5">{description}</p>
            {asterisk && (
              <p className="text-[14px] text-gray-600 italic mt-2 font-trade_gothic_lt_std">
                {asterisk}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionWithImage;
